module.exports = __webpack_public_path__ + "assets/c866e62e0d71e9beb97460f0867a52e5.png";